<script>
	import { base } from '$app/paths';
	let {
		src,
		alt,
		caption,
		width = 1200,
		height = 800,
		eager = false,
		directory = 'kdmgen-help'
	} = $props();
	const screenDimensions = {
		'device-search-screen.webp': [1128, 524],
		'backend-certificate-screen.webp': [1130, 171],
		'batch-registration-screen.webp': [1130, 208],
		'single-cpl-screen.webp': [1130, 491],
		'target-cpls-screen.webp': [1130, 152],
		'validate-screen.webp': [1130, 95],
		'booking-automation-screen.webp': [1130, 294],
		'facility-filters-screen.webp': [1088, 99]
	};
	let dimensions = $derived(
		(directory === 'kdmgen-help' && screenDimensions[src]) || [width, height]
	);
	let imageUrl = $derived(`${base}/${directory}/${src}`);
</script>

<figure class="guide-figure">
	<a href={imageUrl} target="_blank" rel="noopener" aria-label={`Open full-size image: ${caption}`}>
		<img
			src={imageUrl}
			{alt}
			width={dimensions[0]}
			height={dimensions[1]}
			loading={eager ? 'eager' : 'lazy'}
			decoding="async"
		/>
	</a>
	<figcaption>
		<span>{caption}</span><a href={imageUrl} target="_blank" rel="noopener"
			><i class="bx bx-expand-alt" aria-hidden="true"></i> Full size</a
		>
	</figcaption>
</figure>
